import * as React from "react";

const Cross = (props) => (
  <svg
    width={20}
    height={20}
    viewBox={"0 0 20 20"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 5L5 15M5 5l10 10"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Cross;
